import { Text, XStack, YStack } from 'tamagui'
import { Button } from '../../ui/primitives'
import { Icon } from '../../ui/Icon'

/**
 * Вариант A (web): авторинг BookStack встроен в портал через iframe.
 * kb.asgroup.az и портал — один сайт asgroup.az → cookie/SSO работают в iframe
 * (в проде). Требует на стороне BookStack: ALLOWED_IFRAME_HOSTS=https://life.asgroup.az.
 */
export function KbEmbed({
  url,
  title,
  backLabel,
  onBack,
}: {
  url: string
  title: string
  backLabel: string
  onBack: () => void
}) {
  return (
    <YStack flex={1} minHeight="100%" backgroundColor="$bgLayout">
      <XStack
        alignItems="center"
        gap={12}
        paddingHorizontal={16}
        paddingVertical={10}
        borderBottomWidth={1}
        borderColor="$borderSecondary"
        backgroundColor="$background"
      >
        <Button icon={<Icon name="arrow-left" size={16} color="$color" />} onPress={onBack}>
          {backLabel}
        </Button>
        <Text flex={1} fontSize={14} fontWeight="700" color="$color" numberOfLines={1}>
          {title}
        </Text>
      </XStack>
      <iframe
        src={url}
        title={title}
        style={{ border: 0, width: '100%', height: '100%', flex: 1, minHeight: '80vh' }}
      />
    </YStack>
  )
}
